export const TAB_TYPE = {
  POINTS: 'points',
  USER_CREADITS: 'user_creadits',
  PROFILE: 'profile',
};

export const SECTION_STATUS = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  FAILURE: 'failure',
  LOADING: 'loading',
};

export const MOBILE_PHONE_STEP = {
  EMPTY: 'empty',
  CHECK_MOBILE: 'check_mobile',
  ENTER_CODE: 'enter_code',
};
